export interface CloseAttribute {
    code: string
    label: string
    options: { label: string; value: string }[]
}

// Shared percentage options for carriageway/footway condition attributes
const PERCENTAGE_OPTIONS = [
    { label: '0% (000)', value: '000' },
    { label: '10% (010)', value: '010' },
    { label: '20% (020)', value: '020' },
    { label: '30% (030)', value: '030' },
    { label: '40% (040)', value: '040' },
    { label: '50% (050)', value: '050' },
    { label: '60% (060)', value: '060' },
    { label: '70% (070)', value: '070' },
    { label: '80% (080)', value: '080' },
    { label: '90% (090)', value: '090' },
    { label: '100% (100)', value: '100' },
]

const GEN_CONDITION_OPTIONS = [
    { label: 'Not Applicable (NA)', value: 'NA' },
    { label: 'As New (NEW)', value: 'NEW' },
    { label: 'Good (GOOD)', value: 'GOOD' },
    { label: 'Fair (FAIR)', value: 'FAIR' },
    { label: 'Poor (UNSA)', value: 'UNSA' },
    { label: 'Unsatisfactory (POOR)', value: 'POOR' },
]

const SURFACE_STATE_OPTIONS = [
    { label: 'dry (DRY)', value: 'DRY' },
    { label: 'fog (FOG)', value: 'FOG' },
    { label: 'ice (ICE)', value: 'ICE' },
    { label: 'Not Applicable (NA)', value: 'NA' },
    { label: 'snow (SNO)', value: 'SNO' },
    { label: 'wet (WET)', value: 'WET' },
]

const FOOTWAY_PRESENCE_OPTIONS = [
    { label: 'other mix (1)', value: '1' },
    { label: 'one side (2)', value: '2' },
    { label: 'two sides (3)', value: '3' },
    { label: 'none present (4)', value: '4' },
    { label: 'Not Applicable (NA)', value: 'NA' },
]

const REDUCED_INSPECTION_OPTIONS = [
    { label: 'Assessed (ASS)', value: 'ASS' },
    { label: 'Restricted Inspection (RI)', value: 'RI' },
    { label: 'Restricted Uninspected (RU)', value: 'RU' },
    { label: 'Not Assessed (NA)', value: 'NA' },
]

const REINSPECTION_OPTIONS = [
    { label: 'Yes (YES)', value: 'YES' },
    { label: 'No (NO)', value: 'NO' },
    { label: 'Not Applicable (NA)', value: 'NA' },
]

export const WEATHER_OPTIONS = [
    { label: 'Dry', value: 'H010' },
    { label: 'Damp', value: 'H020' },
    { label: 'Wet', value: 'H030' },
    { label: 'Flooded/Puddles', value: 'H040' },
    { label: 'Ice', value: 'H050' },
    { label: 'Snow', value: 'H060' },
    { label: 'Bright & Dry', value: 'H070' },
    { label: 'Bright & Wet', value: 'H080' },
    { label: 'Other - add notes', value: 'H090' },
    { label: 'Not Assessed', value: 'NA' },
]

export const DEFECT_OPTIONS = [
    { label: 'Not Assessed', value: 'NA' },
    { label: 'No Safety Defects Observed', value: 'SANO' },
    { label: 'Defects identified & recorded', value: 'Y' },
]

export const FEEDBACK_OPTIONS = [
    { label: 'No', value: 'H010' },
    { label: 'Yes - Please add notes', value: 'H020' },
    { label: 'Not Assessed', value: 'NA' },
]

export const ESS_CLOSE_ATTRIBUTES: CloseAttribute[] = [
    { code: 'CWQE', label: 'Carriageway Excellent', options: PERCENTAGE_OPTIONS },
    { code: 'CWQG', label: 'Carriageway Good', options: PERCENTAGE_OPTIONS },
    { code: 'CWQF', label: 'Carriageway Fair', options: PERCENTAGE_OPTIONS },
    { code: 'CWQS', label: 'Carriageway Requires Improvement', options: PERCENTAGE_OPTIONS },
    { code: 'CYCN', label: 'Cycleway Condition', options: GEN_CONDITION_OPTIONS },
    { code: 'FWCN', label: 'Footway Condition', options: GEN_CONDITION_OPTIONS },
    { code: 'SSTT', label: 'Surface State', options: SURFACE_STATE_OPTIONS },
    { code: 'FWPC', label: 'Footway Presence', options: FOOTWAY_PRESENCE_OPTIONS },
    { code: 'FFQE', label: 'Footway Excellent', options: PERCENTAGE_OPTIONS },
    { code: 'FFQG', label: 'Footway Good', options: PERCENTAGE_OPTIONS },
    { code: 'FFQF', label: 'Footway Fair', options: PERCENTAGE_OPTIONS },
    { code: 'FFQS', label: 'Footway Requires Improvement', options: PERCENTAGE_OPTIONS },
    { code: 'RI', label: 'Reduced Inspection', options: REDUCED_INSPECTION_OPTIONS },
    { code: 'RR', label: 'Re-inspection Required', options: REINSPECTION_OPTIONS },
]

export const SCC_CLOSE_ATTRIBUTES: CloseAttribute[] = [
    { code: 'H005', label: 'HW: Weather', options: WEATHER_OPTIONS },
    { code: 'H011', label: 'HW: Defects', options: DEFECT_OPTIONS },
    { code: 'H012', label: 'HW: Feedback', options: FEEDBACK_OPTIONS },
]
